import { Flex } from '@mantine/core';
import { TFunction } from 'i18next';

import { LabelValue } from 'components';

interface ICreditRequestInfoData {
  creditAmount?: number;
  monthlyInstallmentTo?: number;
  paymentPeriod?: number;
  t: TFunction;
}

const CreditRequestInfoData = ({
  creditAmount,
  monthlyInstallmentTo,
  paymentPeriod,
  t,
}: ICreditRequestInfoData) => {
  return (
    <Flex>
      {creditAmount ? <LabelValue label={t('input.creditAmount.request.label')} value={t('input.creditAmount.request.value', { amount: creditAmount })} /> : undefined}
      {paymentPeriod ? <LabelValue label={t('input.paymentPeriod.request.label')} value={t('input.paymentPeriod.request.value', { amount: paymentPeriod })} /> : undefined}
      {monthlyInstallmentTo ? <LabelValue label={t('input.monthlyInstallment.request.label')} value={t('input.monthlyInstallment.request.value', { amount: monthlyInstallmentTo })} /> : undefined}
    </Flex>
  )
}

export default CreditRequestInfoData;